import { Component, Input, ViewContainerRef } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { FormState, NgrxFormsModule } from 'ngrx-forms';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrackFieldfocusDirective } from '@analytics/events';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import {
  ValidationClassesDirective,
  HasValueDirective,
} from '@innogy/utils-deprecated';

@Component({
  selector: 'wl-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.scss'],
  standalone: true,
  imports: [
    AutomationIdDirective,
    NgrxFormsModule,
    AutomationIdDirective,
    ValidationClassesDirective,
    HasValueDirective,
    TrackFieldfocusDirective,
    CommonUiUtilityComponentsModule,
  ],
})
export class PhoneComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formsControl?: FormState<string>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() placeholder = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() label = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() tooltip = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stepName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fieldName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() hashValue?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() sendValue? = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() step?: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() floatingLabel = true;

  constructor(private readonly viewContainerRef: ViewContainerRef) {}

  public onFocus() {
    if (this.formsControl != null) {
      this.dispatchNativeEvent('focus');
    }
  }

  private dispatchNativeEvent(eventName: string) {
    this.viewContainerRef.element.nativeElement.dispatchEvent(
      new Event(eventName)
    );
  }
}
